import { jsxs, jsx } from 'react/jsx-runtime';
import { FormatWithLinearLocale } from '../../utils/format.mjs';
import CalendarHeader from '../base/CalendarHeader.mjs';

const DEFAULT_MONTH_LABEL_FORMAT = {
  en: "yyyy",
  ko: "yyyy\uB144"
};
function Header({ year, onClickPrevYear, onClickNextYear }) {
  return /* @__PURE__ */ jsxs(CalendarHeader, { children: [
    /* @__PURE__ */ jsx(CalendarHeader.DateText, { children: /* @__PURE__ */ jsx(
      FormatWithLinearLocale,
      {
        date: new Date(year, 0),
        formatMap: DEFAULT_MONTH_LABEL_FORMAT
      }
    ) }),
    /* @__PURE__ */ jsxs(CalendarHeader.RightSlot, { children: [
      /* @__PURE__ */ jsx(CalendarHeader.PrevIconButton, { onClick: onClickPrevYear }),
      /* @__PURE__ */ jsx(CalendarHeader.NextIconButton, { onClick: onClickNextYear })
    ] })
  ] });
}

export { Header as default };
//# sourceMappingURL=Header.mjs.map
